// Sticky ATC quantity sync fix for Tinker theme
document.addEventListener('DOMContentLoaded', () => {
  const syncStickyATC = () => {
    // Find all product-form-component elements on the page
    const allForms = document.querySelectorAll('product-form-component');
    if (allForms.length < 2) return; // Only needed when there are 2 forms (main + sticky)

    const mainForm = allForms[0];
    const stickyForm = allForms[1];

    const mainQty = mainForm.querySelector('input[name="quantity"]');
    const stickyQty = stickyForm.querySelector('input[name="quantity"]');

    if (!mainQty || !stickyQty) return;

    // Sync sticky qty from main on load
    stickyQty.value = mainQty.value;

    // Keep sticky qty in sync when main qty changes
    mainQty.addEventListener('change', () => {
      stickyQty.value = mainQty.value;
    });
    mainQty.addEventListener('input', () => {
      stickyQty.value = mainQty.value;
    });

    // Prevent the main form from submitting when sticky ATC is clicked
    const stickySubmitBtn = stickyForm.querySelector('button[name="add"]');
    if (stickySubmitBtn) {
      stickySubmitBtn.addEventListener('click', (e) => {
        // Sync quantity one more time right before submit
        stickyQty.value = mainQty.value;
      });
    }
  };

  syncStickyATC();
});
